import { render, staticRenderFns } from "./PolicyCaribe.vue?vue&type=template&id=a27450a2&scoped=true&"
import script from "./PolicyCaribe.vue?vue&type=script&lang=js&"
export * from "./PolicyCaribe.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCaribe.vue?vue&type=style&index=0&id=a27450a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27450a2",
  null
  
)

export default component.exports